module.exports = __webpack_public_path__ + "static/media/Logowhite.222cd36f.png";